import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Ease } from '../_app/cuchillo/utils/Ease';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

export class ScrollItem__BlockDefault extends VScroll_Item {
    number;
    title = [];
    img = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setAnimations();

        this.onShow = () => {
            this.showFunction();
        };
        this.onHide = () => {
            this.hideFunction();
        };
        this.onMove = () => {
            this.moveFunction();
        };
    }

    setAnimations() {
        const number = GetBy.selector('.number', this.item);
        if (number.length > 0) {
            this.number = new SplitText(number, {
                type: 'chars',
                tag: 'span'
            }).chars;
            gsap.set(this.number, { y: '100%' });
        }

        const title = GetBy.selector('.title', this.item);
        if (title.length > 0) {
            this.title = new SplitText(title, {
                type: 'lines'
            }).lines;
            gsap.set(this.title, { y: '100%' });
        }

        this.img = GetBy.selector('.__img', this.item);
        if (this.img.length > 0) {
            gsap.set(this.img, { opacity: 0 });
        }
    }

    showFunction() {
        let delay = 0;

        if (this.img.length > 0) {
            for (let i = 0; i < this.img.length; i++) {
                const img = this.img[i];
                gsap.to(img, {
                    delay: i * .2,
                    opacity: 1,
                    duration: 1,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }

        if (this.number) {
            for (let i = 0; i < this.number.length; i++) {
                const num = this.number[i];
                gsap.to(num, {
                    y: 0,
                    delay: i * .05,
                    duration: 1,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }

            delay += .2;
        }

        if (this.title.length > 0) {
            for (let i = 0; i < this.title.length; i++) {
                const title = this.title[i];
                gsap.to(title, {
                    y: 0,
                    delay: delay + i * .2,
                    duration: 1.6,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }
    }

    hideFunction() { }

    moveFunction() { }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);
